module.exports = "<div class=\"cat__footer\">\n   <a href=\"javascript: void(0);\" class=\"cat__core__scroll-top\" onclick=\"$('body, html').animate({'scrollTop': 0}, 500);\"><i class=\"icmn-arrow-up\"></i></a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = main